import { interact } from "fire-wind-water";
import { common } from "@/model/common";
import BaseComponent from "@/components/BaseComponent";
import { registerModel } from "@/model/register-model";
import configMixin from "@/mixin/config";
import Header from "@/components/Header";
import Banner from "@/components/Banner";
// import { URLSearchParams } from "core-js/modules/web.url-search-params";

export default {
  name: "bindRegister",
  components: {
    Header,
    Banner,
    BaseComponent,
  },
  mixins: [configMixin],
  data() {
    return {
      weChatId: common.weChatId,
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      backUrl: common.backUrl,
      formInfo: null,
      token: common.token,
      tokenInfo: "",
      verify: common.verify,
      formList: [],
      inWeChat: interact.isWeChat,
      isLoad: false,
      isSubmitting: false,
    };
  },
  methods: {
    routerBindLogin() {
      common.routerPush(this, "bindLogin", { token: this.token });
    },
    afterLoadForm() {
      let self = this;
      let token = common.getToken();
      let tokenInfo = common.getTokenInfo();
      if (!token || !tokenInfo) {
        window.$sk.tips.show(this.$t("login.pleaseAuthorizeFirst"));
        common.routerPush(self, "login", {
          memberSchemaId: self.formInfo.schemaId,
        });
      } else {
        self.token = token;
        self.tokenInfo = tokenInfo;
      }
    },
    beforeRegisterHandler() {
      registerModel.beforeRegisterHandler(this);
    },
    afterRegisterHandler() {
      common.removeToken();
      common.removeTokenInfo();
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      registerModel.loadForm(this);
    },
    skLinkEnd() {
      this.verify = common.getVerify(this.weChatId);
    },
  },
  created() {
    window.$sk.loading.show();
    this.sk = window.$sk.template.module(this);
  },
  mounted() {},
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
